<template>
	<div class="contact__element contact__select">
		<label v-if="content.title"
					 :for="selectTitle.toLowerCase().replace(' ', '-')"
					 class="select__label">
			{{ selectTitle }}
		</label>
		<select :name="selectTitle.toLowerCase().replace(' ', '-')"
						:id="selectTitle.toLowerCase().replace(' ', '-')"
						class="select__input">
			<option v-for="option in content.select"
							:value="locale === 'en' ? option.en.toLowerCase().replace(' ', '-') : option.jp.toLowerCase().replace(' ', '-')">
				{{ locale === 'en' ? option.en : option.jp }}
			</option>
		</select>
	</div>
</template>

<script setup>
	import { useI18n, useLocalePath } from '#imports'
	import { computed } from 'vue'
	const { locale } = useI18n()
	const localePath = useLocalePath()
	const props = defineProps({
		content: Object
	})
	let selectTitle
	if(props.content.title) {
		selectTitle = computed(() => locale.value === 'en' ? props.content.title.en : props.content.title.jp )
	}
</script>

<style lang="scss">
@use '@/assets/sass/variables.scss' as v;
.contact__select {
	.select__label {
		display: block;
		font-family: var(--font);
		font-weight: 900;
		margin: 0 0 0.5rem 0;
	}
	.select__input {
		border: 0.05rem solid v.$lightGrey;
		display: block;
		width: 100%;
		padding: 1rem;
		&:focus {
			border: 0.05rem solid v.$teal;
			box-shadow: 0 0 7px -3px v.$teal;
			outline: none;
			transition: 0.3s;
		}
	}
}
</style>
